<mat-slide-toggle
  [hideIcon]="true"
  *ngIf="viewMode !== viewModes.View"
  class="spacing--padding-top"
  [checked]="showAdditives"
  (change)="setShowAdditives(!showAdditives)"
  data-test="create-show-additive"
>
  {{ 'feed-advice.create.show-additives' | translate }}
</mat-slide-toggle>

<ng-container *ngIf="showAdditives">
  <h3 class="text--h3 spacing--padding-top">{{ 'feed-advice.create.additives' | translate }}</h3>
  <!-- table -->
  <agr-table
    (keydown.enter)="$event.preventDefault()"
    [config]="tableConfig"
    (change)="updateDataSource()"
    [isEmpty]="false"
    class="spacing--padding-bottom"
  ></agr-table>
  <!-- [enableStepArrows]="true" -->

  <div class="flex--column" *ngIf="viewMode !== viewModes.View">
    <div class="mat-button-row spacing--margin-top">
      <button
        type="button"
        mat-flat-button
        color="primary"
        data-test="create-feed-advice__add-additive"
        (click)="addAdditiveRow()"
      >
        {{ 'feed-advice.create.add-additive' | translate }}
      </button>
    </div>
  </div>
</ng-container>

<ng-template #nameTemplate let-row="row">
  <mat-select
    [hideSingleSelectionIndicator]="true"
    *ngIf="viewMode === viewModes.Create || viewMode === viewModes.Edit"
    class="text--small"
    [value]="getAdditive(row)"
    placeholder="{{ 'feed-advice.create.product-placeholder' | translate }}"
    (selectionChange)="selectAdditive($event, row)"
    data-test="create-feed-advice__additiverows_product-selector"
  >
    <mat-option *ngFor="let product of additives$ | async" [value]="product">
      {{ product.code }} - {{ product.name }}
    </mat-option>
  </mat-select>
  <span *ngIf="viewMode === viewModes.View">
    {{ row.product?.code }} - {{ row.product?.name }}
  </span>
</ng-template>
